import React, { useState } from "react";
import { Button, TextField, Radio, RadioGroup, FormControlLabel, Box, Typography } from "@mui/material";

const AjustarDesconto = ({ onClose, tipoDesconto, setTipoDesconto, valorDesconto, setValorDesconto }) => {


    const handleChangeTipo = (event) => {
        setTipoDesconto(event.target.value);
        setValorDesconto("");
    };

    const handleSalvar = () => {
        onClose();
    };

    return (
        <Box>
            <Typography variant="h6" mb={2}>
                Ajustar Desconto
            </Typography>
            <RadioGroup value={tipoDesconto} onChange={handleChangeTipo} row>
                <FormControlLabel value="porcentagem" control={<Radio />} label="Porcentagem" />
                <FormControlLabel value="valor" control={<Radio />} label="Valor" />
            </RadioGroup>
            <TextField
                fullWidth
                label={tipoDesconto === "porcentagem" ? "Desconto (%)" : "Desconto (R$)"}
                type="number"
                value={valorDesconto}
                onChange={(e) => setValorDesconto(e.target.value)}
                margin="normal"
            />
            <Box display="flex" justifyContent="space-between" mt={2}>
                <Button variant="contained" color="error" onClick={onClose}>
                    Cancelar
                </Button>
                <Button variant="contained" color="primary" onClick={handleSalvar}>
                    Salvar
                </Button>
            </Box>
        </Box>
    );
};

export default AjustarDesconto;
